<template lang="pug">
  v-dialog(:value="value" @input="value = $event.target.value" persistent)
    v-card
      v-card-title(class="headline") Deseja realmente deletar o registro?
      v-card-text O registro será permanentemente removido da base de dados.
      v-card-actions
        v-spacer
        v-btn(color="blue darken-4" text @click="cliqueNao") Não
        v-btn(color="blue darken-4" text @click="cliqueSim") Sim
</template>

<script>
export default {
  name: "dialog-delete",
  props: {
    value: {
      type: Boolean,
      default: true
    }
  },
  methods:{
    cliqueSim(){
      this.$emit('evento-sim')
    },
    cliqueNao(){
      this.$emit('evento-nao')
    }
  }
}
</script>
